/* eslint-disable */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CampaignPackageDto, ProductsWithPackages } from '@app/interfaces/voucher';

export interface VoucherState {
  voucher: any;
  productsWithPackages?: ProductsWithPackages;
  selectedPackagesByProduct: Record<string, CampaignPackageDto[]>;
}

const initialState: VoucherState = {
  voucher: null,
  productsWithPackages: undefined,
  selectedPackagesByProduct: {},
};
// export const setVoucher = createAction<PrepareAction<Voucher>>('voucher/setVoucher', (voucher: Voucher) => {
//   sessionStorage.setItem('token', voucher.Key);
//   return {
//     payload: voucher,
//   };
// });
const voucherSlice = createSlice({
  name: 'voucherSlice',
  initialState,
  reducers: {
    setVoucher(state, action: PayloadAction<any>) {
      state.voucher = action.payload;
    },

    setProductsWithPackages(state, action: PayloadAction<ProductsWithPackages | undefined>) {
      state.productsWithPackages = action.payload;
    },

    setSelectedPackagesByProduct(state, action: PayloadAction<Record<string, CampaignPackageDto[]>>) {
      state.selectedPackagesByProduct = action.payload || {};
    },

    toggleSelectedPackage(
      state,
      action: PayloadAction<{
        productId: string;
        packageItem: CampaignPackageDto;
        checked: boolean;
      }>,
    ) {
      const { productId, packageItem, checked } = action.payload;
      const current = state.selectedPackagesByProduct[productId] || [];

      const packageId = String((packageItem as any)?.Id ?? (packageItem as any)?.id);

      if (checked) {
        const existed = current.some((x: any) => String(x?.Id ?? x?.id) === packageId);

        if (!existed) {
          state.selectedPackagesByProduct[productId] = [...current, packageItem];
        }
      } else {
        state.selectedPackagesByProduct[productId] = current.filter((x: any) => String(x?.Id ?? x?.id) !== packageId);
      }
    },

    resetSelectedPackages(state) {
      state.selectedPackagesByProduct = {};
    },
  },
});

export const {
  setVoucher,
  setProductsWithPackages,
  setSelectedPackagesByProduct,
  toggleSelectedPackage,
  resetSelectedPackages,
} = voucherSlice.actions;

export default voucherSlice.reducer;
